import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';

import * as keyboardEventHelpers from 'globals/keyboardEvents';
import style from './styles';

class ChatFormEnumButton extends React.PureComponent {
  handleKeyPress = e => {
    const { onClick, displayName, value, disabled } = this.props;

    if (keyboardEventHelpers.isEnterKey(e)) {
      e.preventDefault();
      e.stopPropagation();

      if (disabled) return;

      onClick(value, displayName);
    }
  };

  handleClick = () => {
    const { onClick, displayName, value, disabled, endChat } = this.props;

    if (disabled) return;

    onClick(value, displayName, endChat);
  };

  getSafeButtonMessage(message) {
    let safeMessage = message;

    if (message && message.length > 80) {
      safeMessage = `${safeMessage.substring(0, 80)}...`;
    }

    return safeMessage;
  }
  render() {
    const { displayName, disabled, label } = this.props;

    const message = label || displayName;
    const safeMessage = this.getSafeButtonMessage(message);

    return (
      <button
        tabIndex="0"
        style={style.button}
        onClick={this.handleClick}
        onKeyPress={this.handleKeyPress}
        disabled={disabled}
        className="kustomer-app-reply-input-option"
      >
        <span aria-label={safeMessage} style={style.innerText}>
          {safeMessage}
        </span>
      </button>
    );
  }
}

ChatFormEnumButton.propTypes = {
  onClick: PropTypes.func,
  displayName: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  endChat: PropTypes.bool,
};

ChatFormEnumButton.defaultProps = {
  onClick() {},
  disabled: false,
  label: null,
  endChat: false,
};

export default Radium(ChatFormEnumButton);
